module.exports = __webpack_public_path__ + "static/media/task-management.1ac22a5a.md";